/** @deprecated use the component in the `@owl-nest/services` module */
export { Banner } from '@owl-nest/services/src/message/components/Banner'
